import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  constructor(private meta: Meta, private titleService: Title) {
    this.meta.updateTag({ name: 'description', content: "Edstate's Privacy Policy: Your online privacy matters. Learn about data protection rights, cookie usage, and more. Contact us for queries or concerns." });
    titleService.setTitle("Edstate Privacy Policy | Data Protection, Cookies, and User Rights");
   }

  ngOnInit() {
  }

}
